import "./shimmer.css";

const TableLoader = ({ rows = 8, columns = 6, height = 500 }) => (
  <div className="shimmer-table-loader" style={{ height }}>
    <div className="shimmer-table-header">
      {Array.from({ length: columns }).map((_, index) => (
        <div key={index} className="shimmer-block" />
      ))}
    </div>
    <div className="shimmer-table-body">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="shimmer-table-row">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div key={colIndex} className="shimmer-block" />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default TableLoader;
